/**
 * Auto-switch country/currency from visitor IP via Shopify Markets.
 * Respects a manual country choice set by the country selector.
 */
(function () {
  const MANUAL_KEY = 'bhx_localization_manual';
  const CHECKED_KEY = 'bhx_auto_localization_checked';

  if (typeof window === 'undefined') return;
  if (window.Shopify && Shopify.designMode) return;
  if (!window.themeLocalization || window.themeLocalization.autoEnabled === false) return;

  try {
    if (localStorage.getItem(MANUAL_KEY) === '1') return;
    if (sessionStorage.getItem(CHECKED_KEY) === '1') return;
  } catch (e) {
    // Storage blocked — still attempt auto localization once per page load.
  }

  const root =
    (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  const currentCountry = String(
    (window.Shopify && Shopify.country) || ''
  ).toUpperCase();
  const currentLanguage = String(
    (window.Shopify && (Shopify.language || Shopify.locale)) || ''
  ).toLowerCase();

  const url =
    root +
    'browsing_context_suggestions.json' +
    '?country[enabled]=true' +
    '&country[exclude]=' +
    encodeURIComponent(currentCountry) +
    '&language[enabled]=true' +
    '&language[exclude]=' +
    encodeURIComponent(currentLanguage);

  fetch(url)
    .then(function (response) {
      if (!response.ok) throw new Error('Suggestions unavailable');
      return response.json();
    })
    .then(function (data) {
      markChecked();

      const suggestion = data && data.suggestions && data.suggestions[0];
      if (!suggestion || !suggestion.parts || !suggestion.parts.country) return;

      const country = String(suggestion.parts.country.handle || '').toUpperCase();
      if (!country || country === currentCountry) return;

      const language = suggestion.parts.language
        ? String(suggestion.parts.language.handle || currentLanguage).toLowerCase()
        : currentLanguage || 'en';

      submitLocalization(country, language);
    })
    .catch(function () {
      markChecked();
    });

  function markChecked() {
    try {
      sessionStorage.setItem(CHECKED_KEY, '1');
    } catch (e) {}
  }

  function submitLocalization(country, language) {
    if (document.getElementById('AutoLocalizationForm')) return;

    const form = document.createElement('form');
    form.id = 'AutoLocalizationForm';
    form.method = 'POST';
    form.action = root + 'localization';
    form.hidden = true;

    const fields = {
      _method: 'PUT',
      country_code: country,
      language_code: language,
      return_to: window.location.pathname + window.location.search + window.location.hash
    };

    Object.keys(fields).forEach(function (name) {
      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = name;
      input.value = fields[name];
      form.appendChild(input);
    });

    document.body.appendChild(form);
    form.submit();
  }

  window.themeLocalization = window.themeLocalization || {};
  window.themeLocalization.markManualPreference = function () {
    try {
      localStorage.setItem(MANUAL_KEY, '1');
    } catch (e) {}
  };
})();
